import { useEffect } from "react";
import { auth } from "../services/firebase";
import history from "../History";
import * as ROUTES from "../constants/routes";

const SignOutPage = () => {
  useEffect(() => {
    auth().signOut();
    history.push(ROUTES.SIGN_IN);
  }, []);
  return null;
};

export default SignOutPage;
